const getSlug = (path: string): string => {
  if (!path) {
    return "";
  }
  const regex = /\/\d*-?(\w+)\.md/;
  const match = path.match(regex);
  return match ? match[1] : "";
};

export default getSlug;
